<template>
    <div :style="{'height' : 500 +'px' }">
        <div class="form-single">
            <div class="title">设备名称</div>
            <div class="content">
                <label class="mr20">{{shopDeviceSvcSubNoInfo.title || ''}}</label>
            </div>
        </div>
        <div class="form-single">
            <div class="title">系统编号</div>
            <div class="content">
                <label class="mr20">{{shopDeviceSvcSubNoInfo.tmpNo || ''}}</label>
            </div>
        </div>
        <div class="table-layout mt10">
            <el-table :data="servcWorkVoucherList" border height="400">
                <el-table-column prop="servcReqVoucher.no" label="请求单号" width="160" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="servcReqVoucher.requestTime" label="请求时间" width="160" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="servcReqVoucher.servcName" label="请求服务" width="120" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="servcReqVoucher.requestDesc" label="请求描述" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="servcReqVoucher.troubleDesc" label="问题描述" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="报修图片" width="90" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.servcWorkRepairImgFileList != null && rows.row.servcWorkRepairImgFileList.length > 0">
                            <img :src="img.fileBrowseUrl" v-for="img in rows.row.servcWorkRepairImgFileList">
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="no" label="工单编号" width="170" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="紧急状态" prop="emgLevel" width="80" align="center">
                    <template slot-scope="rows">
                        <span :class="rows.row.emgLevel == 0 ? 'font-green' : rows.row.emgLevel == 1 ? 'font-orange' : 'font-red'">{{emgLevelMap[rows.row.emgLevel]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="modelSpec" label="工单状态" width="100" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.invalid">已作废</span>
                        <span class="font-red" v-else-if="rows.row.close">已关闭</span>
                        <span class="font-black" v-else>{{workAssignState[rows.row.state]}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="80" label="是否评价" class="align-left">
                    <template slot-scope="rows">
                        <span v-if="rows.row.evalFlag">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="chargeItemNames" label="服务项目" width="130" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="repairTypeName" label="维修类型" width="100" align="center" show-overflow-tooltip>
                    <!--<tmplate socpe="rows">-->
                    <!--<span>{{repairTypeList[rows.row.repairType]}}</span>-->
                    <!--</tmplate>-->
                </el-table-column>
                <el-table-column prop="faultTypeName" label="故障类型" width="100" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="faultDesc" label="故障描述" width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="维修图片" width="90" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.servcWorkImgFileList != null && rows.row.servcWorkImgFileList.length > 0">
                            <img :src="img.fileBrowseUrl" v-for="img in rows.row.servcWorkImgFileList">
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout" v-if="totalCount > 0">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-device-repair-rec-info',
        desc: '设备-【维保记录】',
        props: ["tmpNo"],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                shopDeviceSvcSubNoInfo: {},
                servcWorkVoucherList: [],
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                //
                workAssignState: [],
                repairTypeList: [],
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.workAssignState = getEnumMap("workAssignState", "value2text");
            this.repairTypeList = getEnumMap("repairType", "value2text");
            //
            this.getShopDeviceSvcSubNo();
        },
        methods: {
            // 获取设备信息
            getShopDeviceSvcSubNo: function () {
                let self = this;
                let postData = {};
                postData.tmpNo = this.tmpNo;
                let theLoad = MsgBox.loading();
                servcDelivApi.getShopDeviceSvcSubNo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.shopDeviceSvcSubNoInfo = result.data;
                        //
                        self.getServcWorkVoucherByTmpNo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServcWorkVoucherByTmpNo();
            },
            getServcWorkVoucherByTmpNo: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };
                let filterItems = {};
                filterItems.tmpNo = this.tmpNo;
                postData.filterItems = filterItems;
                //
                let theLoading = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherByTmpNo(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.servcWorkVoucherList = result.data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            downloadFile: function (fileUuid) {
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + fileUuid));
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/DeviceRepairRec.vue